export const DEFAULT_ROWS_PER_PAGE = [10, 20, 30, 40];
